// ====================================================================================
// CCM19 JavaScript Module
// ====================================================================================
import { domReady } from "../functions/utility.js";

// example code for the module
// <script
//   type="text/x-ccm-loader"
//   data-ccm-loader-group="d.vinci"
//   data-ccm-loader-src="https://..."
//   data-ccm-card="true"
//   data-ccm-ref=".dvinci-job-widget"
//   data-ccm-title="<p class='title'><strong>Stellenangebote via D.Vinci</strong></p>"
//   data-ccm-text="Um Ihnen unsere aktuellen Stellenangebote anzeigen zu können benötigen wir Ihre Zustimmung zur Datenverarbeitung durch D.Vinci.\nBitte Stimmen Sie diesen zu."
//   data-ccm-button="Cookie-Zustimmung ändern"
//   ></script>
// <div class="dvinci-job-widget" />

const BUTTON_CLASS = "btn";
const DEFAULT_TEXT =
    "Dieses Element benötigt eine Zustimmung zur Datenverarbeitung.";
const DEFAULT_BUTTON_TEXT = "Cookie-Zustimmung ändern";

const isHTML = (str) => /<[a-z][\s\S]*>/i.test(str);

const createInformationCard = (group, data) => {
    const cardTitle = data.ccmTitle || group;
    const titleHTML = isHTML(cardTitle) ? cardTitle : `<h2>${cardTitle}</h2>`;

    const cardText = data.ccmText || DEFAULT_TEXT;
    let textHTML = isHTML(cardText) ? cardText : `<p>${cardText}</p>`;
    textHTML = textHTML.replace(/(\r\n|\r|\n|\\n)/g, "<br/>");

    const card = document.createElement("div");
    card.className = "ccm-info-card";
    card.setAttribute("ccm-data-group", group);
    card.innerHTML = `${titleHTML}${textHTML}`;

    const button = document.createElement("button");
    button.className = `ccm-info-button ${BUTTON_CLASS}`;
    button.textContent = data.ccmButton || DEFAULT_BUTTON_TEXT;
    button.onclick = () => CCM.openControlPanel();

    card.appendChild(button);
    return card;
};

const handleContentReload = (data) => {
    if (data.ccmCard !== "true") return;
    if (!data.ccmRef) return;

    const hasContent = Array.from(document.querySelectorAll(data.ccmRef)).some(
        (el) => el.innerHTML.trim() !== ""
    );

    if (hasContent) window.location.reload();
};

const processGroupElement = (element, group, isAccepted) => {
    if (!element || !element.dataset) return;
    if (element.dataset.ccmCard !== "true") return;

    const groupElements = document.querySelectorAll(
        `[data-ccm-loader-group="${group}"]`
    );

    if (groupElements.length === 0) return;

    groupElements.forEach((el) => {
        if (el.dataset.ccmCard !== "true") return;

        let infoCard = el.parentElement.querySelector(".ccm-info-card");

        if (!infoCard) {
            const newInfoCard = createInformationCard(group, el.dataset);
            el.parentElement.appendChild(newInfoCard);
            infoCard = el.parentElement.querySelector(".ccm-info-card");
        }

        if (isAccepted) {
            infoCard.style.setProperty("display", "none");
            return;
        } else {
            handleContentReload(el.dataset);
        }
    });
};

const processEvent = () => {
    const embeddings = CCM.acceptedEmbeddings;
    if (!embeddings?.length) return;

    const groups = [
        ...new Set(
            Array.from(document.querySelectorAll("[data-ccm-loader-group]"))
                .map((el) => el.getAttribute("data-ccm-loader-group"))
                .filter(Boolean)
        ),
    ];

    groups.forEach((group) => {
        const groupElements = document.querySelectorAll(
            `[data-ccm-loader-group="${group}"]`
        );

        if (groupElements.length === 0) return;

        const normalizedGroup = group.trim().toLowerCase();
        const isAccepted = embeddings.some((e) => {
            let name = e.name.trim().toLowerCase();
            return name.includes(normalizedGroup);
        });
        groupElements.forEach((el) =>
            processGroupElement(el, group, isAccepted)
        );
    });
};

export const init = () => {
    domReady().then(() => {
        
        if (typeof CCM === "undefined") return;

        const hasGroups = document.querySelector("[data-ccm-loader-group]");
        if (!hasGroups) return;

        processEvent();

        ["ccm19WidgetLoaded", "ccm19WidgetClosed"].forEach((event) => {
            window.addEventListener(event, processEvent);
        });
    });
};